import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import { CookiesProvider } from 'react-cookie';
import { useCookies } from 'react-cookie';
import Chat from './components/Chat/Chat';
import Login from './components/Auth/Login';
import Registration from './components/Auth/Registration';
import MicrosoftCallback from './components/Auth/MicrosoftCallback'
import Sidebar from './components/Sidebar/Sidebar';
import History from './components/History/History';
import NewChat from './components/NewChat/NewChat';
import Settings from './components/Settings/Settings';
import ResetPasswordPage from './components/resetpassword/ResetPasswordPage';
import './styles/global.css';
import AboutAI from './components/about/AboutAI.jsx';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ForgetPasswordPage from './components/fogetpassword/ForgetPasswordPage.jsx';

const App = () => {
  const [cookies] = useCookies(['token']);

  const ProtectedRoute = ({ children }) => {

    if (!cookies.token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <CookiesProvider>
      <GoogleOAuthProvider clientId="142758292298-9tivpaftvgcphtib0n35fso3eqehjmfp.apps.googleusercontent.com">
        <Router>
          <Routes>

            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/forget-password" element={<ForgetPasswordPage />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/auth/microsoftcallback" element={<MicrosoftCallback />} />
            <Route path="/c/:chatId" element={
              <ProtectedRoute>
                <Sidebar />
                <Chat />
              </ProtectedRoute>
            } />
            <Route path="/" element={
              <ProtectedRoute>
                <Sidebar />
                <Chat />
              </ProtectedRoute>
            } />
            <Route path="/history" element={
              <ProtectedRoute>

                <Sidebar />
                <History />

              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>

                <Sidebar />
                <Settings />

              </ProtectedRoute>
            } />
            <Route path="/new-chat" element={
              <ProtectedRoute>

                <Sidebar />
                <NewChat />

              </ProtectedRoute>
            } />
            <Route path="/about-ai" element={
              <ProtectedRoute>
                <div className="wrapper">
                  <Sidebar />
                  <AboutAI />
                </div>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </GoogleOAuthProvider>
    </CookiesProvider >
  );
};

export default App;